export enum DialogBeforeunloadResponseType {
  Accept = 1,
  Reject = 2,
  Close = 3,
}
